<template>
  <div>
    <div
      class="page-header clear-filter"
      filter-color="black"
      style="min-height: 1200px !important;"
    >
      <div
        style="position:absolute; left:0px; top:0px; position: absolute; z-index: -1;
      background-image: url('/img/img_land.png');
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        width: 100%;
        height: 100%;"
      ></div>
      <div class="container" id="top">
        <div
          style="position: absolute; top: 95px; left: calc(50% - 60px - 183px); width: 183px; height: 109px; z-index: 400; background-image: url('/img/event/bg_land_lv2.png');"
        >
          <div style="position: relative; top: 12px; right: 6px; text-align: right;">
            <span style="color: yellow; font-size: 18px; font-weight: 600;">{{remainLands[0][0]}}</span>
            <span style="color: white; font-size: 16px; font-weight: 300;">/ {{remainLands[0][1]}}</span>
          </div>
        </div>
        <div
          style="position: absolute; top: 95px; right: calc(50% - 60px - 183px); width: 183px; height: 109px; z-index: 400; background-image: url('/img/event/bg_land_lv1.png');"
        >
          <div style="position: relative; top: 12px; left: 6px; text-align: left;">
            <span style="color: yellow; font-size: 18px; font-weight: 600;">{{remainLands[1][0]}}</span>
            <span style="color: white; font-size: 16px; font-weight: 300;">/ {{remainLands[1][1]}}</span>
          </div>
        </div>
        <div class="row" style="margin-top: 60px; text-align: center; z-index: 200;">
          <div
            style="position: relative; background-image: url('/img/event/frame.png'); background-size: 100% 100%; width: calc(50vh + 25px); height: calc(50vh + 25px); padding: 10px; margin-left: calc((100% - (50vh + 25px)) / 2);  z-index: 200;"
          >
            <FortuneWheel
              type="image"
              style="width: 100%; height: 100%;"
              btnWidth="100%"
              bordercolor="#ffffff"
              v-bind:fontSize="16"
              v-bind:borderWidth="4"
              v-bind:email="loginInfo.email"
              :prizes="prizes"
              v-bind:disabled="loginInfo.email == '' || loginInfo.remainRoullete <= 0 || eventEnded"
              @onRotateStartError="onRotateStartError"
              @onRotateStart="onRotateStart"
              @onRotateEnd="onRotateEnd"
            >
              <img slot="wheel" src="/img/event/roulette.png" />
              <img slot="button" src="/img/event/btn_go.png" />
            </FortuneWheel>
            <img
              src="/img/event/arrow.png"
              style="position: absolute; top: -15px; left: calc(50% - 22px);"
            />
          </div>
        </div>
        <div
          style="position: relative;margin: -140px auto; width: 448px; height: 350px; background-image: url('/img/event/bg_flag.png'); background-size: 100% 100%; padding-top: 150px;"
        >
          <div
            style="position: absolute; top: 110px; right: 50px; width: 30px; height: 30px; cursor: pointer; z-index: 400;"
            @click="openTable()"
          >
            <img src="/img/event/btn_notice.png" />
          </div>
          <div v-if="loginInfo.email == ''">
            <input
              type="text"
              v-model="email"
              v-bind:placeholder="`Email`"
              style="color: white; margin: 10px auto; background-color: transparent; border: none; width: 270px; height: 44px; padding-left: 20px; background-image: url('/img/event/bg_email_box.png');"
            />
            <div
              style="width: 270px; height: 68px; background-image: url('/img/btn_270.png'); font-size: 1.0em;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            text-align: center;
            margin: 10px auto;
            color: #fff568; padding-top: 23px;"
              @click="subscribe()"
              class="btn"
            >{{$t('button_join')}}</div>
          </div>
          <div v-else style="color: #fff">
            <h5
              v-if="loginInfo.status == 'confirmed'"
              style="font-size: 16px; color:#00ffff;"
            >{{loginInfo.email}}</h5>
            <h5 v-else style="font-size: 16px; color:#00ffff;">
              {{loginInfo.email}}
              <span style="color:#dd0000;">[{{$t('unidentified')}}]</span>
            </h5>
            <img src="/img/event/line.png" style="margin-top: -30px;" />
            <h5
              style="color:#ffffff; font-size: 16px; margin-top: -20px;"
            >{{$t('remain_wheel')}} : {{loginInfo.remainRoullete}}</h5>
            <div
              style="width: 270px; height: 68px; background-image: url('/img/btn_270.png'); font-size: 1.0em;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            text-align: center;
            margin: auto;
            color: #fff568; padding-top: 23px;"
              @click="openAddRoullete()"
              class="btn"
            >{{$t('button_free_wheel')}}(+ 1)</div>
          </div>
        </div>
        <div
          style="position: relative; width: 511px; height: 212px; margin: 150px auto; background-image: url('/img/event/bg_history.png');"
        >
          <div
            style="position: absolute; top: 10px; left: 0px; height: 40px; text-align: center; width: 100%; color: white;"
          >HISTORY</div>
          <div
            class="scrollbox"
            style="position: absolute; height: calc(100% - 50px); width: calc(100% - 40px); top: 40px; left: 20px;  overflow-y: auto; text-align: left;"
          >
            <div v-for="log in history" v-bind:key="log._id">
              <span style="color: #00dd55;">{{log.logDate | date}}</span>
              <span style="color: #dddddd;">{{log.email}} /</span>
              <span v-bind:style="{color: `${getPrizeColor(log.id)}`}">{{getPrizeName(log.id)}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="position: fixed; left: 0px; top: 0px; width: 100%; height: 100%; background-color: #00000099; cursor: pointer; z-index: 900;" v-if="visibleShare || visibleAddRoullete || visibleTable" @click="closeAll()">
      <div v-if="visibleShare" style="position: absolute; left: 0px; top: 0px; width: 100%; height: 100%;">
        <img class="rotating" src="/img/event/fx.png" style="position: relative; left: calc((100% - 1000px)/2); top: calc((100% - 1000px)/2);">
      </div>
    </div>
    <div
      v-if="visibleShare"
      style="position: fixed; top: calc((100% - 536px) / 2); left: calc((100% - 530px) / 2); padding-top: 30px; text-align: center; width: 530px; height: 536px; background-image: url('/img/event/bg_pop.png'); z-index: 10000;"
    >
      <div
        style="position: absolute; top: 28px; right: 30px; width: 40px; height: 40px; cursor: pointer;"
        @click="closeShare()"
      >
        <img src="/img/event/btn_close.png" />
      </div>
      <p
        style="color: white; font-weight: 900; font-size: 24px; height: 80px;"
      >{{$t('info_congrats')}}</p>
      <p
        style="color: #07245c; font-weight: 600; font-size: 20px; height: 60px;"
        v-html="$t('info_congrats_prize1', [prizeName])"
      ></p>
      <p
        style="color: #07245c; font-weight: 300; font-size: 18px; height: 100px;"
        v-html="$t('info_congrats_prize2')"
      ></p>

      <!-- <n-button type="danger" @click="closeShare()" style="margin: auto;">{{$t('CLOSE')}}</n-button> -->
      <social-sharing
        v-bind:url="shareInfo.shareUrl"
        v-bind:title="$t('media_prize_title')"
        v-bind:description="$t('media_prize_desc', [prizeName])"
        v-bind:quote="$t('media_prize_desc', [prizeName])"
        v-bind:hashtags="$t('media_prize_hashtags')"
        inline-template
        network-tag="div"
      >
        <div style="text-align: center;">
          <div
            style="background-color: #3b5998; color: white; cursor: pointer; margin: 10px auto; width: 300px; height: 50px; padding-top: 14px;"
          >
            <network
              network="facebook"
              style="width: 100%; height: 100%;"
            >Facebook {{$t('media_share')}}</network>
          </div>
          <div
            style="background-color: #55acee; color: white; cursor: pointer; margin: 10px auto; width: 300px; height: 50px; padding-top: 14px;"
          >
            <network
              network="twitter"
              style="width: 100%; height: 100%;"
            >Twitter {{$t('media_share')}}</network>
          </div>
          <div
            style="background-color: #ff4500; color: white; cursor: pointer; margin: 10px auto; width: 300px; height: 50px; padding-top: 14px;"
          >
            <network
              network="reddit"
              style="width: 100%; height: 100%;"
            >Reddit {{$t('media_share')}}</network>
          </div>
        </div>
      </social-sharing>
    </div>
    <div
      v-if="visibleAddRoullete"
      style="position: fixed; top: calc((100% - 536px) / 2); left: calc((100% - 530px) / 2); padding-top: 30px; text-align: center; width: 530px; height: 536px; background-image: url('/img/event/bg_pop.png'); z-index: 10000;"
    >
      <div
        style="position: absolute; top: 28px; right: 30px; width: 40px; height: 40px; cursor: pointer;"
        @click="closeAddRoullete()"
      >
        <img src="/img/event/btn_close.png" />
      </div>
      <p
        style="color: white; font-weight: 900; font-size: 24px; height: 60px;"
      >{{$t('button_free_wheel')}}</p>
      <p
        style="color: #07245c; font-weight: 600; font-size: 20px; height: 60px; padding-left: 40px; padding-right: 40px;"
        v-html="$t('info_share')"
      ></p>
      <p
        style="color: #07245c; font-weight: 300; font-size: 14px; height: 120px; padding-left: 40px; padding-right: 40px; text-align: left;"
      >
        - {{$t('warn_event_1')}}
        <br />
        - {{$t('warn_event_2')}}
      </p>

      <!-- <n-button type="danger" @click="closeShare()" style="margin: auto;">{{$t('CLOSE')}}</n-button> -->
      <div style="text-align: center;" v-if="!sharing">
        <social-sharing
          v-if="canShare('facebook')"
          v-bind:url="shareInfo.shareUrl"
          v-bind:title="$t(`media_share${shareTypes.facebook}_title`)"
          v-bind:description="$t(`media_share${shareTypes.facebook}_desc`)"
          v-bind:quote="$t(`media_share${shareTypes.facebook}_desc`)"
          v-bind:hashtags="$t(`media_share${shareTypes.facebook}_hashtags`)"
          inline-template
          @close="onCloseShare"
          @open="onOpenShare"
          @change="onChangeShare"
          network-tag="div"
        >
          <div
            style="background-color: #3b5998; color: white; cursor: pointer; margin: 10px auto; width: 300px; height: 50px; padding-top: 14px;"
          >
            <network
              network="facebook"
              style="width: 100%; height: 100%;"
            >Facebook {{$t('media_share')}}</network>
          </div>
        </social-sharing>
        <social-sharing
          v-if="canShare('twitter')"
          v-bind:url="shareInfo.shareUrl"
          v-bind:title="$t(`media_share${shareTypes.twitter}_desc`)"
          v-bind:description="$t(`media_share${shareTypes.twitter}_desc`)"
          v-bind:quote="$t(`media_share${shareTypes.twitter}_desc`)"
          v-bind:hashtags="$t(`media_share${shareTypes.twitter}_hashtags`)"
          inline-template
          @close="onCloseShare"
          @open="onOpenShare"
          @change="onChangeShare"
          network-tag="div"
        >
          <div
            style="background-color: #55acee; color: white; cursor: pointer; margin: 10px auto; width: 300px; height: 50px; padding-top: 14px;"
          >
            <network
              network="twitter"
              style="width: 100%; height: 100%;"
            >Twitter {{$t('media_share')}}</network>
          </div>
        </social-sharing>
        <social-sharing
          v-if="canShare('reddit')"
          v-bind:url="shareInfo.shareUrl"
          v-bind:title="$t(`media_share${shareTypes.reddit}_desc`)"
          v-bind:description="$t(`media_share${shareTypes.reddit}_desc`)"
          v-bind:quote="$t(`media_share${shareTypes.reddit}_desc`)"
          v-bind:hashtags="$t(`media_share${shareTypes.reddit}_hashtags`)"
          inline-template
          @close="onCloseShare"
          @open="onOpenShare"
          @change="onChangeShare"
          network-tag="div"
        >
          <div
            style="background-color: #ff4500; color: white; cursor: pointer; margin: 10px auto; width: 300px; height: 50px; padding-top: 14px;"
          >
            <network
              network="reddit"
              style="width: 100%; height: 100%;"
            >Reddit {{$t('media_share')}}</network>
          </div>
        </social-sharing>
      </div>
      <div v-if="sharing">
        <input
          type="text"
          v-model="shareUrl"
          v-bind:placeholder="$t('placeholder_url')"
          style="color: white; position: absolute; top: 290px; left: 22px; background-color: transparent; border: none; width: 487px; height: 44px; padding-left: 20px; background-color: #081132;"
        />
        <!-- <fg-input
          class="no-border"
          v-bind:placeholder="$t('placeholder_url')"
          v-model="shareUrl"
          style="margin-top: 10px;"
        ></fg-input>-->
        <n-button
          type="primary"
          @click="checkShare()"
          style="font-size: 16px; font-weight: 600; width: 300px; height: 60px; position: absolute; top: 350px; left: calc((100% - 300px)/2); "
        >{{$t('button_check_share')}}</n-button>
        <n-button
          type="danger"
          @click="reShare()"
          style="font-size: 16px; font-weight: 600; width: 300px; height: 60px; position: absolute; top: 420px; left: calc((100% - 300px)/2); "
        >{{$t('button_reset_share')}}</n-button>
      </div>
    </div>
    <div
      v-if="visibleTable"
      style="position: fixed; top: calc((100% - 716px) / 2); left: calc((100% - 530px) / 2); padding-top: 0px; text-align: center; width: 530px; height: 716px; background-image: url('/img/event/bg_pop2.png'); z-index: 10000;"
    >
      <p
        style="color: #121e36; font-weight: 900; font-size: 24px; height: 30px;"
      >{{$t('wheel_of_fortune')}}</p>
      <table class="tablecss" style="margin: 10px 25px;">
        <tr class="tablecss" style="max-height: 28px;">
          <th class="thcss" style="width: 300px;">{{$t('prize_name')}}</th>
          <th class="thcss" style="width: 150px;">{{$t('prize_total')}}</th>
          <th class="thcss" style="width: 150px;">{{$t('prize_remain')}}</th>
          <th class="thcss" style="width: 150px;">{{$t('prize_value')}}</th>
          <th class="thcss" style="width: 150px;">{{$t('prize_prob')}}</th>
        </tr>
        <tr
          v-for="table in tables"
          v-bind:key="table.id"
          v-bind:style="{'color':`#000000`, 'background-color': getGradeColor(table.grade)}"
        >
          <td class="tdcss">{{getPrizeName(table.id)}}</td>
          <td class="tdcss" v-if="table.total < 0">{{$t('prize_unlimited')}}</td>
          <td class="tdcss" v-else>{{table.total | comma}}</td>
          <td class="tdcss" v-if="table.total < 0">{{$t('prize_unlimited')}}</td>
          <td class="tdcss" v-else>{{table.remain | comma}}</td>
          <td class="tdcss">USD {{table.price}}</td>
          <td class="tdcss">{{table.prob.toFixed(4)}}%</td>
        </tr>
      </table>
      <div
        class="scrollbox"
        style="position: absolute; height: 155px; width: 480px; bottom: 100px; left: 25px;  overflow-y: auto; text-align: left; padding-top: 15px; padding-left: 10px; padding-right: 10px;"
      >
        <p style="color: #dddddd; font-size: 15px; font-weight: 300; text-align: left;">
          - {{$t('warn_event_1')}}
          <br />
          - {{$t('warn_event_2')}}
          <br />
          - {{$t('warn_event_3')}}
          <br />
          - {{$t('warn_event_4')}}
          <br />
          - {{$t('warn_event_5')}}
          <br />
          - {{$t('warn_event_6')}}
        </p>
      </div>
      <n-button
        type="primary"
        @click="closeTable()"
        style="font-size: 16px; font-weight: 600; width: 300px; height: 60px; position: absolute; bottom: 20px; left: calc((100% - 300px)/2); "
      >{{$t('CLOSE')}}</n-button>
    </div>
    <div v-if="eventEnded" style="position: fixed; width: 80%; height: 100px; left: 10%; top: calc((100% - 100px)/2); background-color: #00000088; color: white; text-align: center; padding-top: 20px; font-size: 30px; font-weight: 900;">
      감사합니다. 이벤트가 종료되었습니다.
    </div>
  </div>
</template>
<script>
import { Button, FormGroupInput } from "@/components";
import { Popover } from "element-ui";
import FortuneWheel from "../components/FortuneWheel.vue";
import config from "../config.js";
import axios from "axios";
import SocialSharing from "vue-social-sharing";
import moment from "moment";

const gradeColor = ["#A3B7DA", "#167DEF", "#9C1EEE", "#FF6E00"];

export default {
  name: "event",
  bodyClass: "event-page",
  components: {
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    [Popover.name]: Popover,
    FortuneWheel,
    SocialSharing
  },
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    date(val) {
      if (val) {
        return moment(String(val)).format("YYYY-MM-DD HH:mm");
      }
    }
  },
  methods: {
    getShareNetworkType() {
      const shareNetworks = ["facebook", "twitter", "reddit"];
      for (let i = 0; i < shareNetworks.length; ++i) {
        let shareType = 1;
        for (let j = 0; j < this.shareNetworkInfo.length; ++j) {
          let networkInfo = this.shareNetworkInfo[j];
          if (networkInfo.network == shareNetworks[i]) {
            ++shareType;
          }
        }
        this.shareTypes[shareNetworks[i]] = shareType;
      }
    },
    onRotateStart(data) {
      this.loginInfo = {
        _id: data._id,
        email: data.email,
        status: data.status,
        numRoullete: data.numRoullete,
        remainRoullete: data.remainRoullete
      };
      this.shareNetworkInfo = data.shared;
      this.todayShareNetworkInfo = data.todayShared;
      this.getShareNetworkType();
      this.selectedId = data.selectedId;
    },
    onRotateStartError(err) {
      if (err != null && err.code == 'event_ended') {
        this.eventEnded = true;
        return;
      }

      if (this.loginInfo.email == "") {
        alert(this.$t("alert_need_subscribe"));
        return;
      }
      if (this.loginInfo.status != "confirmed") {
        alert(this.$t("info_email_confirm"));
        return;
      }
      alert(this.$t("alert_no_wheel"));
      this.openAddRoullete();
    },
    onRotateEnd(prize) {
      //alert(prize.value);
      this.visibleShare = true;
    },
    // onShare() {
    //   console.log("shareNetworkInfo - ", this.shareNetworkInfo);
    //   this.visibleShare = true;
    // },
    closeAll() {
        this.closeShare();
        this.closeAddRoullete();
        this.closeTable();
    },
    closeShare() {
      this.visibleShare = false;
    },
    openAddRoullete() {
      if (this.eventEnded) {
        return;
      }
      if (this.loginInfo.status != "confirmed") {
        alert(this.$t("info_email_confirm"));
        return;
      }
      this.visibleAddRoullete = true;
      this.sharing = false;
    },
    closeAddRoullete() {
      this.visibleAddRoullete = false;
    },
    openTable: async function() {
      if (this.eventEnded) {
        return;
      }
      await this.loadTable();
      this.visibleTable = true;
    },
    closeTable() {
      this.visibleTable = false;
    },
    onOpenShare(param1, param2, param3) {},
    onChangeShare(param1, param2, param3) {},
    onCloseShare(param1, param2, param3) {
      if (param1 == "facebook") {
        if (!this.canShare("fb")) {
          alert(this.$t("alert_already_share", ["Facebook"]));
          return;
        }
      } else if (param1 == "twitter") {
        if (!this.canShare("tw")) {
          alert(this.$t("alert_already_share", ["Twitter"]));
          return;
        }
      } else if (param1 == "reddit") {
        if (!this.canShare("rd")) {
          alert(this.$t("alert_already_share", ["Reddit"]));
          return;
        }
      }
      this.shareInfo.shareNetwork = param1;
      this.sharing = true;
    },
    canShare(shareNetwork) {
      let numConfirmed = 0;
      for (let i = 0; i < this.shareNetworkInfo.length; ++i) {
        let networkInfo = this.shareNetworkInfo[i];
        if (networkInfo.network == shareNetwork) {
          ++numConfirmed;
        }
      }
      if (numConfirmed >= 4) {
        return false;
      }
      for (let i = 0; i < this.todayShareNetworkInfo.length; ++i) {
        let networkInfo = this.todayShareNetworkInfo[i];
        if (
          networkInfo.network == shareNetwork &&
          networkInfo.status == "confirmed"
        ) {
          return false;
        }
      }
      return true;
    },
    reShare() {
      this.sharing = false;
    },
    checkShare: async function() {
      let shareUrl = this.shareUrl.trim();
      let shareType = 1;
      for (let i = 0; i < this.shareNetworkInfo.length; ++i) {
        let networkInfo = this.shareNetworkInfo[i];
        if (networkInfo.network == this.shareInfo.shareNetwork) {
          ++shareType;
        }
      }

      let ret = await axios.post(
        `${config.api.stat_url}/preregist/checkShare`,
        {
          email: this.loginInfo.email,
          shareUrl: shareUrl,
          shareNetwork: this.shareInfo.shareNetwork,
          type: shareType
        }
      );
      if (ret.data.result == false) {
        if (ret.data.err.code == "already_checked") {
          alert(this.$t("alert_already_share"));
        } else if (ret.data.err.code == "already_checked_account") {
          alert(this.$t("alert_already_share_account"));
        } else if (ret.data.err.code == "failed_check") {
          alert(this.$t("alert_fail_check"));
        } else if (ret.data.err.code == "already_checking") {
          alert(this.$t("alert_fail_checking"));
        } else {
          alert(this.$t("alert_fail_check_unknown"));
        }
        shareUrl = "";
      } else {
        alert(this.$t("info_success_check"));
        this.selectedId = 0;
        this.reShare();
        this.loginInfo = {
          _id: ret.data._id,
          email: ret.data.email,
          status: ret.data.status,
          numRoullete: ret.data.numRoullete,
          remainRoullete: ret.data.remainRoullete
        };
        this.shareNetworkInfo = ret.data.shared;
        this.todayShareNetworkInfo = ret.data.todayShared;
        this.getShareNetworkType();
        this.visibleShare = false;
      }
    },
    subscribe: async function() {
      let email = this.email.trim();
      if (email.length < 3) {
        alert(this.$t(`alert_invalid_email`));
        return;
      }
      let device = "";
      if (this.$device.mobile) {
        device = "mobile/";
        if (this.$device.android || this.$device.androidPhone) {
          device += "android";
        } else {
          device += "ios";
        }
      } else {
        device = "pc";
      }
      let parameters = JSON.parse(localStorage.parameters);
      let ret = await axios.post(
        `${config.api.stat_url}/preregist/subscribe2`,
        {
          email: email,
          utm_source: parameters.utm_source,
          utm_medium: parameters.utm_medium,
          ref: parameters.ref,
          device: device,
          language: navigator.language,
          language2: this.$i18n.locale,
          from: "land"
        }
      );
      if (ret.data.result == false) {
        alert(this.$t(`alert_${ret.data.err.code}`));
      } else {
        if (ret.data.sendMail == true) {
          alert(this.$t("info_email_confirm"));
        }
        this.loginInfo = {
          _id: ret.data._id,
          email: ret.data.email,
          status: ret.data.status,
          numRoullete: ret.data.numRoullete,
          remainRoullete: ret.data.remainRoullete
        };
        this.shareNetworkInfo = ret.data.shared;
        this.todayShareNetworkInfo = ret.data.todayShared;
        this.getShareNetworkType();
        this.selectedId = ret.data.selectedId;
        this.shareInfo.shareUrl = `https://www.leagueofkingdoms.com/?ref=${ret.data._id}`;
      }
    },
    loadHistory: async function() {
      let ret;
      if (this.history.length == 0) {
        ret = await axios.post(
          `${config.api.stat_url}/preregist/event/history`,
          {
            email: this.loginInfo.email
          }
        );
      } else {
        let lastHistory = this.history[0];
        ret = await axios.post(
          `${config.api.stat_url}/preregist/event/history`,
          {
            lastId: lastHistory._id,
            email: this.loginInfo.email
          }
        );
      }
      if (ret.data.result == true) {
        let history = ret.data.history;
        for (let i = 0; i < this.history.length; ++i) {
          history.push(this.history[i]);
        }
        this.history = history;
        this.remainLands = ret.data.land;
        if (ret.data.numRoullete != null) {
          this.loginInfo = {
          _id: ret.data._id,
          email: ret.data.email,
          status: ret.data.status,
          numRoullete: ret.data.numRoullete,
          remainRoullete: ret.data.remainRoullete
        };
        }
      }
    },
    loadTable: async function() {
      let ret = await axios.post(
        `${config.api.stat_url}/preregist/event/table`,
        {}
      );
      if (ret.data.result == true) {
        this.tables = ret.data.table;
      }
    },
    getPrizeName(prizeId) {
      return this.$t(`prize_${prizeId}`);
    },
    getPrizeColor(prizeId) {
      for (let i = 0; i < this.prizes.length; ++i) {
        if (this.prizes[i].id == prizeId) {
          return this.prizes[i].bgColor;
        }
      }
      return "";
    },
    getGradeColor(grade) {
      return gradeColor[grade - 1];
    }
  },
  computed: {
    prizeName() {
      return this.getPrizeName(this.selectedId);
    }
  },
  mounted: async function() {
    this.eventEnded = this.$store.state.account.presaleStarted;
    await this.loadHistory();
    this.timerId = setInterval(async () => {
      await this.loadHistory();
    }, 10000);
  },
  beforeDestroy: function() {
    if (this.timerId != null) {
      clearInterval(this.timerId);
      this.timerId = null;
    }
  },
  data: function() {
    return {
      eventEnded: false,
      shareTypes: {
        facebook: 1,
        twitter: 1,
        reddit: 1
      },
      timerId: null,
      tables: [],
      remainLands: [
        [0, 0],
        [0, 0]
      ],
      history: [],
      selectedId: 0,
      sharing: false,
      visibleShare: false,
      visibleTable: false,
      visibleAddRoullete: false,
      email: "",
      loginInfo: {
        _id: "",
        email: "",
        numRoullete: 0,
        remainRoullete: 0,
        status: "unidentified"
      },
      shareNetworkInfo: [],
      todayShareNetworkInfo: [],
      shareUrl: "",
      shareInfo: {
        shareNetwork: "",
        shareUrl: ""
      },
      prizeId: 1,
      prizes: [
        {
          id: 9,
          name: "Crystal 10",
          value: "Crystal 10",
          bgColor: gradeColor[0],
          color: "#ffffff",
          probability: 12.5
        },
        {
          id: 6,
          name: "GoldChest 3",
          value: "GoldChest 3",
          bgColor: gradeColor[2],
          color: "#ffffff",
          probability: 12.5
        },
        {
          id: 3,
          name: "Crystal 100",
          value: "Crystal 100",
          bgColor: gradeColor[1],
          color: "#ffffff",
          probability: 12.5
        },
        {
          id: 4,
          name: "Crystal 1000",
          value: "Crystal 1000",
          bgColor: gradeColor[2],
          color: "#ffffff",
          probability: 12.5
        },
        {
          id: 2,
          name: "Land 1",
          value: "Land 1",
          bgColor: gradeColor[3],
          color: "#ffffff",
          probability: 12.5
        },
        {
          id: 5,
          name: "GoldChest 1",
          value: "GoldChest 1",
          bgColor: gradeColor[1],
          color: "#ffffff",
          probability: 12.5
        },
        {
          id: 8,
          name: "ResourceChest 3",
          value: "ResourceChest 3",
          bgColor: gradeColor[2],
          color: "#ffffff",
          probability: 12.5
        },
        {
          id: 10,
          name: "SilverChest 1",
          value: "SilverChest 1",
          bgColor: gradeColor[0],
          color: "#ffffff",
          probability: 12.5
        },
        {
          id: 7,
          name: "ResourceChest 1",
          value: "ResourceChest 1",
          bgColor: gradeColor[1],
          color: "#ffffff",
          probability: 12.5
        },
        {
          id: 1,
          name: "Land 2",
          value: "Land 2",
          bgColor: gradeColor[3],
          color: "#ffffff",
          probability: 12.5
        }
      ]
    };
  }
};
</script>
<style>
.scrollbox {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.scrollbox::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera*/
}
.tablecss {
  border: 1px solid black !important;
  min-width: 0px !important;
  min-height: 0px !important;
}
.tdcss {
  border: 1px solid black !important;
  min-width: 0px !important;
  min-height: 0px !important;
  max-height: 36px !important;
  height: 36px !important;
}
.thcss {
  border: 1px solid black !important;
  min-width: 0px !important;
  min-height: 0px !important;
  max-height: 28px !important;
  height: 28px !important;
}

input,
textarea:focus {
  outline: none;
}

@keyframes rotating
    {
    from
        {
        transform: rotate(0deg);
        -o-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        }
    to
        {
        transform: rotate(360deg);
        -o-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        }
    }
@-webkit-keyframes rotating
    {
    from
        {
        transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        }
    to
        {
        transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        }
    }
.rotating
    {
    -webkit-animation: rotating 8s linear infinite;
    -moz-animation: rotating 8s linear infinite;
    -ms-animation: rotating 8s linear infinite;
    -o-animation: rotating 8s linear infinite;
    animation: rotating 8s linear infinite;
    }
</style>
